import { cn } from '../../lib/cn';
import type { CommercialCheckRow } from '../../enterprisebeta/framework';

type Props = { checks?: CommercialCheckRow[] };

export function CommercialReadinessPanel({ checks = [] }: Props) {
  return (
    <div className="grid gap-2 sm:grid-cols-2 lg:grid-cols-4">
      {checks.map((c) => (
        <div key={c.check} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <p className="text-sm font-medium">{c.check}</p>
          <p className="mt-1 text-lg font-semibold">{c.score}%</p>
          <span className={cn(
            'mt-1 inline-block text-xs font-medium',
            c.status === 'validated' ? 'text-success-600' : 'text-warning-600',
          )}>
            {c.status}
          </span>
        </div>
      ))}
    </div>
  );
}
